import React, {useEffect} from 'react';
// @ts-ignore
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'


export default function Progress() {
    useEffect(() => {
        NProgress.start()
    }, [])
    useEffect(() => {
        NProgress.done()
    })
    return <React.Fragment/>
}
